import { useEffect } from 'react';

export const useOnMount = (cb) => {
  useEffect(cb, []);
};
